<div class="highlight-banner" id="highlight-banner">
  <!-- <slick class="highlight-banner-slick" autoplay=true autoplay-speed=7000 arrows=true dots=true fade=true speed=1500 draggable=false
      pause-on-focus=false pause-on-hover=false> -->

  <!-- <div *ngIf="!isSubscribed"class="animated-banner-wrapper">
    <lottie-player *ngIf="!isMobile"></lottie-player>
    <div *ngIf="isMobile" class="mobile-animated-banner"></div>
  </div> -->

  <unh-generic-swiper-slider
    [items]="banners"
    [isMobile]="true"
    [swiperConfigs]="swiperConfigsBanners"
  >

    <!-- <ng-container *ngIf="!luss.subscribed && !hasActivePromo">
      <unh-banner-pro></unh-banner-pro>
    </ng-container> -->


    <ng-container *ngIf="hasActivePromo && !isSubscribed">
      <unh-banners-promo
        *ngFor="let promobanner of promobanners"
        [promo]="actualpromo"
        [banner]="promobanner"
      >
      </unh-banners-promo>
    </ng-container>

    <ng-template #genericSwiperItemTemplate let-item>
      <unh-banner-default
        [isSubscribed]="isSubscribed"
        [title]="item.title"
        [subtitle]="item.subtitle"
        [lead]="item.lead"
        [banner]="item.banner"
        [bannermobile]="item.bannerMobile"
        [linktext]="item.linkText"
        [link]="item.link"
        [subscribed]="false"
        [showBoth]="item.showBoth"
        [cta]="item.cta"
        [enabledGetPro]="item.enableGetPro"
        [linkTarget]="item.linkTarget"
        [queryParams]="item.queryParams? item.queryParams : null"
        [state]="item.state ? item.state : null"
      ></unh-banner-default>
    </ng-template>
  </unh-generic-swiper-slider>

  <div class="banners-pagination"></div>
</div>
